module.exports = __webpack_public_path__ + "img/terverifikasi.2408b366.png";